import { ContabilDITypes } from "@/features/contabil/services/types";
import ControleDebitosGatewayAdapter from "@/features/contabil/dashboard/widgets/controleDebitos/adapters/ControleDebitosGatewayAdapter";
import { ControleDebitosPorEmpresaGatewayAdapter } from "@/features/contabil/dashboard/widgets/controleDebitos/adapters/ControleDebitosPorEmpresaGatewayAdapter";
import CriarTabelaDebitosPorEmpresaUseCase from "@/features/contabil/dashboard/widgets/controleDebitos/adapters/CriarTabelaDebitosPorEmpresaUseCase";
import CriarTabelaDebitosUseCase from "@/features/contabil/dashboard/widgets/controleDebitos/adapters/CriarTabelaDebitosUseCase";
import { IControleDebitosGateway } from "@/features/contabil/dashboard/widgets/controleDebitos/ports/ControleDebitosGateway";
import { IControleDebitosPorEmpresaGateway } from "@/features/contabil/dashboard/widgets/controleDebitos/ports/ControleDebitosPorEmpresaGateway";
import { ICriarTabelaDebitosUseCase } from "@/features/contabil/dashboard/widgets/controleDebitos/ports/CriarTabelaDebitos";
import { ControleDebitosDI } from "@/features/contabil/dashboard/widgets/controleDebitos/types";
import { ContainerModule } from "inversify";

const controleDebitosContainer = new ContainerModule((bind) => {
  bind<IControleDebitosGateway>(ContabilDITypes.CONTROLE_DEBITOS_GATEWAY).to(
    ControleDebitosGatewayAdapter
  );
  bind<ICriarTabelaDebitosUseCase>(ControleDebitosDI.CRIAR_TABELA_USECASE).to(
    CriarTabelaDebitosUseCase
  );
  bind<IControleDebitosPorEmpresaGateway>(
    ContabilDITypes.CONTROLE_DEBITOS_POR_EMPRESA_GATEWAY
  ).to(ControleDebitosPorEmpresaGatewayAdapter);
  bind<ICriarTabelaDebitosUseCase>(
    ControleDebitosDI.CRIAR_TABELA_USECASE_POR_EMPRESA
  ).to(CriarTabelaDebitosPorEmpresaUseCase);
});

export { controleDebitosContainer };
